import { getUser } from 'hooks/use-login';
import Cookies from 'js-cookie';
import { useMutation } from 'react-query';
import { api } from 'services/api';
import { GET_IN_AUTH_TOKEN_COOKIE_KEY } from 'utils/constants';

type UseCheckOTPCodeParams = {
  currentFlow: 'sms' | 'email';
  query?: 'user-duplicated';
  params: {
    /**
     * Session hash generated by backend.
     */
    session: string;
    /**
     * User phone with country and ddd.
     */
    code: string;
  };
};

export type CheckSMSCodeResponse = {
  session: string;
  event: string;
  email: string;
  access_token: string;
};

type GetUnitsProps = {
  status: number;
  data: CheckSMSCodeResponse;
};

export const checkOTPCode = async (
  data: UseCheckOTPCodeParams
): Promise<GetUnitsProps> => {
  const { status, data: response } = await api.post(
    `/auth/v3/${data.currentFlow}/${data.query || 'login'}`,
    {
      ...data.params,
    }
  );

  if (status === 200) {
    if (response.data.access_token) {
      Cookies.set(GET_IN_AUTH_TOKEN_COOKIE_KEY, response.data.access_token);
      await getUser();
    }
  }

  return {
    status,
    data: response.data,
  };
};

export const useCheckOPTCode = () => {
  return useMutation('check-otp-code', (params: UseCheckOTPCodeParams) =>
    checkOTPCode(params)
  );
};
